import '@grofers/dock-design-kit/dist/index.css';
import '@grofers/dock-design-kit/dist/css/tokens.css';
import '@grofers/dock-design-kit/dist/css/theme.css';
import '@grofers/dock-design-kit/dist/css/theme-dark.css';
import '@grofers/dock-design-kit/dist/icons/icons.css';
import './index.scss';
import * as Sentry from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider as ReduxStoreProvider } from 'react-redux';
import { ThemeProvider } from '@grofers/dock-design-kit';

import ToastContainer from 'sushiweb/ToastContainer';
import history from './history';
import getStore from './store/store';
import App from './App';
import { GoogleOAuthProvider } from '@react-oauth/google';

//dev-tools
import { InitDatadog } from '../dev-tools/datadog/init.js';
import { InitSentry } from '../dev-tools/sentry/init.js';

import { PRODUCTION_HOST, PREPROD_HOSTS } from './constants/appConst';
import { getCurrentUserEmail, getCurrentUserId } from './utils/CookieToken';

const store = getStore(history);
const OAUTH_CLIENT_ID =
  '385138925165-pdnfns575i09sj468bvkubv5te41utgu.apps.googleusercontent.com';

const hostname = window.location.hostname;
const isProduction = hostname === PRODUCTION_HOST;
const isPreprod = PREPROD_HOSTS.includes(hostname);

if (isProduction) {
  InitSentry();
  InitDatadog();
} else if (isPreprod) {
  InitDatadog();
}

const ErrorFallbackUI = (
  <div className='tw-h-screen tw-flex tw-flex-col tw-items-center tw-justify-center tw-px-40'>
    <span className='tw-text-[3.4rem] tw-font-bold tw-text-center tw-text-zinc-800'>
      An unexpected error has occurred.
    </span>
    <span className='tw-font-medium tw-text-[2.5rem] tw-mt-3 tw-text-center tw-text-zinc-700'>
      Please report this to your POC or TL and ask them to report this to
      Blinkit CD Tech team
    </span>
    <span className='tw-font-medium tw-text-[1.8rem] tw-mt-3 tw-text-center tw-text-zinc-600'>
      ID: {getCurrentUserId()} ({getCurrentUserEmail()})
    </span>
  </div>
);

ReactDOM.render(
  <GoogleOAuthProvider clientId={OAUTH_CLIENT_ID}>
    <Sentry.ErrorBoundary fallback={ErrorFallbackUI}>
      <ThemeProvider defaultTheme='light'>
        <ToastContainer>
          <ReduxStoreProvider store={store}>
            <App />
          </ReduxStoreProvider>
        </ToastContainer>
      </ThemeProvider>
    </Sentry.ErrorBoundary>
  </GoogleOAuthProvider>,
  document.getElementById('root'),
);
